(function () {
    angular.module('acordoCadastro', []);
})();